import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTrackEngagementEvent } from "./useTrackEngagementEvent";
import { EngagementEventTypes } from "../tracking/eventTypes";

export const useAutoPageViewTracking = () => {
  const location = useLocation();
  const { track } = useTrackEngagementEvent();
  const previousPathRef = useRef<string>();

  useEffect(() => {
    if (location.pathname === previousPathRef.current) return;
    previousPathRef.current = location.pathname;
    track(EngagementEventTypes.PAGE_VIEW, 1, { path: location.pathname });
  }, [location.pathname, track]);
};
